import React from 'react';
import Header from '../../components/header';
import BackButton from '../../components/header-back-button';

const InternalPageHeader = props => <Header left={<BackButton/>} {...props}/>;

export default InternalPageHeader;



// WEBPACK FOOTER //
// ./app/containers/internal-page-header/internal-page-header.js